import { Col, Row, Skeleton } from 'ui';

const ProfileFormSkeleton = () => (
  <Row gutter={['xs', 'xs']}>
    <Col span={24}>
      <Row justify="space-between">
        <Col span={8}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
        <Col span={8}>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Row justify="space-between">
        <Col>
          <Skeleton.Avatar active shape="circle" size={160} />
        </Col>
        <Col>
          {/* TODO: fix skeleton, theres no rectangle shape */}
          <Skeleton.Avatar active shape="square" size={160} style={{ height: '160px', width: '248px' }} />
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Row gutter={['xs', 0]}>
        <Col span={12}>
          <Skeleton.Input active block size="large" />
        </Col>
        <Col span={12}>
          <Skeleton.Input active block size="large" />
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      {/** TODO: `lg` input skeleton has min-width 200px and it is overflowing to another input skeleton */}
      <Row gutter={['xs', 'xs']}>
        <Col span={8}>
          <Skeleton.Input active block size="large" />
        </Col>
        <Col span={8}>
          <Skeleton.Input active block size="large" />
        </Col>
        <Col span={8}>
          <Skeleton.Input active block size="large" />
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Row gutter={['xs', 0]}>
        <Col span={12}>
          <Skeleton.Input active block size="large" />
        </Col>
        <Col span={12}>
          <Skeleton.Input active block size="large" />
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block size="large" />
    </Col>
    <Col span={24}>
      <Skeleton.Button active block size="large" />
    </Col>
  </Row>
);

export default ProfileFormSkeleton;
